import React from 'react';
import { format } from 'date-fns';
import styles from 'assets/css/CourseComponent.module.css';
import CoursePartials from 'Components/Card/Partials/Partials.Course';
import { getUTCDateFromServerDate } from 'utils/dateUtils';
import imagesPath, { getImageSource } from 'utils/imgUtils';

function CourseComponent({course, courseImg, wrapperModifierClass, welcomeMessageTitle, locked}) {

    let courseImgResolved = courseImg ? courseImg : getImageSource(course.CourseImageUrl);
    let wrapperModifierClassResolved = wrapperModifierClass ? wrapperModifierClass : course.WrapperModifierClass;
    let welcomeMessageTitleResolved = welcomeMessageTitle ? welcomeMessageTitle : course.WelcomeMessageTitle;
    const showWelcome = course.HasCourse && !course.HasStarted;

    const LastVisited = () => (<p className={styles.lastVisited}>Last viewed {format(getUTCDateFromServerDate(course.LastVisited), 'MMMM dd, yyyy')}</p>);

    return (
        <div className={`${styles.wrapper} ${styles[wrapperModifierClassResolved]}`}>
            {courseImgResolved &&
            <div className={styles.imgWrap}>
                <img src={courseImgResolved} alt={course.HeaderText} />
            </div>}
            <div className={styles.contentWrap}>
                <h4 className={styles.courseHeader}>{course.HeaderText}</h4>
                {course.SubHeaderText && <h4 className={styles.courseSubtitle}>{course.SubHeaderText}</h4>}
                {course.UpgradeRequired && course.UpgradeText && <CoursePartials.Upgrade upgradeText={course.UpgradeText} upgradeIcon={course.UpgradeIcon} />}

                {showWelcome && <CoursePartials.Welcome welcomeMessageTitle={welcomeMessageTitleResolved} />}
                {course.LastVisited && <LastVisited />}
                {course.PercentageComplete > 0 && <CoursePartials.Progress {...course} />}
                {<CoursePartials.BodyCopy bodyStateCopy={course.BodyStateCopy} />}
                {locked && <CoursePartials.LockedBtn />}
                {!locked && <CoursePartials.CardLink {...course} />}
            </div>
        </div>
    )
}

export default CourseComponent;
